export default {
    page_title: "Vendas",
    confirm_delete: {
        title: "Excluir vendas",
        body_singular: "Deletar a venda da base é uma ação irreversível.",
        body_plural: "Deletar as vendas da base é uma ação irreversível.",
        warning: "Essa exclusão é permanente.",
        inconsistency_singular: "Deletar a venda pode gerar inconsistências nos relatórios da Kevi, que deixarão de refletir os mesmos números do ERP.",
        inconsistency_plural: "Deletar as vendas pode gerar inconsistências nos relatórios da Kevi, que deixarão de refletir os mesmos números do ERP.",
        instruction: "Digite a seguinte frase para confirmar a ação:",
        phrase_singular: "EXCLUIR {0} VENDA PERMANENTEMENTE",
        phrase_plural: "EXCLUIR {0} VENDAS PERMANENTEMENTE",
        button: "Excluir",
    },
    more_actions: "Mais ações",
    remove_all: "Remover todos",
    export: "Exportar",
    table: {
        id: "ID",
        date: "Data",
        status: "Status",
        value: "Valor",
        client: "Cliente",
        phone: "Telefone",
        email: "E-mail",
    },
    filters: {
        client_segment: "Segmento do cliente",
        order_status: "Status do Pedido",
    },
    export_headers: {
        id: "Id",
        date: "Data",
        status: "Status",
        value: "Valor",
        client: "Cliente",
        phone: "Telefone",
        email: "E-mail",
        external_id: "Id Externo",
    },
    deleted_success: "Pedidos deletados",
    select_all: "Selecionar todos",
    unselect_all: "Desmarcar todos",
    selection: {
        count: "{$0} selecionado{$1}",
        export: "Exportar selecionados",
        remove: "Remover selecionados",
    },
    export_selected_success: "{$0} pedido{$1} exportado{$2}",
    delete_selected_success: "{$0} pedido{$1} deletado{$2}",
};
